var tabsI18n = {
  scrollStartButton: 'Scroll Start',
  scrollEndButton: 'Scroll End'
};
export default tabsI18n;